import React from "react";

import { Box, IconButton, Tooltip, Typography } from "@mui/material";

const AiIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M7.29492 5.6377H9.41273V15.9998H7.29492V5.6377Z"
      fill="currentColor"
    />
    <path
      d="M3.1767 5.1084C1.42508 5.1084 0 6.53347 0 8.28509V16H2.11781V12.7476H4.23562V16H6.35342V8.28513C6.35339 6.53347 4.92835 5.1084 3.1767 5.1084ZM4.23562 10.6298H2.11781V8.28509C2.11781 7.70122 2.59282 7.22621 3.1767 7.22621C3.76057 7.22621 4.23558 7.70122 4.23558 8.28509V10.6298H4.23562Z"
      fill="currentColor"
    />
    <path
      d="M13.4842 2.51614L12.1081 0L10.732 2.51614L8.21582 3.89228L10.732 5.26842L12.1081 7.78456L13.4842 5.26842L16.0004 3.89228L13.4842 2.51614Z"
      fill="currentColor"
    />
  </svg>
);

interface TabHeaderProps {
  handleGenerate?: (args?: unknown) => void;
  isGenerating?: boolean;
  icon: React.ReactNode;
  title: string;
  actions?: React.ReactNode;
}

const TabHeader: React.FC<TabHeaderProps> = ({
  handleGenerate,
  isGenerating = false,
  icon,
  title,
  actions,
}) => {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 1.5,
        py: 1.5,
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            p: .75,
            borderRadius: 1.5,
            color: "text.primary",
            backgroundColor: "#E3DED2",
          }}
        >
          {icon}
        </Box>
        <Typography variant="text15B">
          {title}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        {actions && actions}
        {handleGenerate && (
          <Tooltip title="Draft with Luna" arrow>
            <IconButton
              onClick={() => handleGenerate?.()}
              disabled={isGenerating}
              sx={{
                p: .75,
                border: "1px solid",
                borderColor: "secondary.main",
                borderRadius: 1.5,
                color: "text.primary",
                "&.Mui-disabled": {
                  color: "text.disabled",
                  borderColor: "divider",
                },
              }}
            >
              <AiIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default TabHeader;
